import React, {Fragment} from 'react';
import {Gallery, Icons, UI, Popup, TagsList, Flex, Collaboration, SyncIcon} from 'components';
import {moment, useNamedSelector} from 'helpers';
import {store, notes} from 'store';
import css from './card.module.scss';

export function Card({ id, Status = Collaboration.CardStatus, ActionMenu = Popup.Menu.Handle, ...props }) {
  const { Card } = UI;
  const { images, note, category, editable, saved, disabled } = useNamedSelector('notes.details', { id, context: 'notes' });
  const Icon = Icons[category && category.id] || Icons.CustomCategory;
  return (
    <Card navLink={editable && `/notes/${note.id}/`} id={note.id} disabled={disabled} {...props}>
      <Status selector="notes.details" id={id} />
      <ActionMenu Menu={Menu} note={note} id={id} editable={editable} disabled={disabled} />
      <Card.Body>
        {note.title && <Card.Text>{note.title}</Card.Text>}
        <Card.Note className="is-long-text">{ note.text || 'Empty note.' }</Card.Note>
        <TagsList values={note.tagIds} unclickable />
        <Gallery images={images} />
      </Card.Body>
      <Card.Footer>
        <Flex className={css[category && category.id]}>
          { saved
            ? <Icon />
            : <SyncIcon />
          }
          <span>{ moment.unix(note.date).calendar() }</span>
        </Flex>
      </Card.Footer>
    </Card>
  );
}

function Menu({ note }) {
  return (
    <Fragment>
      <Popup.Menu.Item icon="pencil" to={`/notes/${ note.id }/`}>Edit</Popup.Menu.Item>
      <Collaboration.MenuItem id={note.id} context="notes" />
      <Popup.Menu.DeleteItem onConfirm={() => store.dispatch(notes.remove(note))}>Delete</Popup.Menu.DeleteItem>
    </Fragment>
  );
}
